import React, { useState } from 'react'

export const RouterContext = React.createContext()

export const WithRouterContext = (Component) => (props) => (
    <RouterContext.Consumer>
        {(routerContext) => (
            <Component routerContext={routerContext} {...props} />
        )}
    </RouterContext.Consumer>
)

export function RouterProvider(props) {
    const [path, setPath] = useState('')

    return (
        <RouterContext.Provider
            value={{
                path,
                setPath,
            }}
        >
            {props.children}
        </RouterContext.Provider>
    )
}
